import gql from "graphql-tag";

export const MY_LEAVE_GET_BADGES = gql`
  query myLeaveBadges($contract: String!) {
    myLeaveBadges(contract: $contract) {
      urgentLeaveRequestsCount
      allLeaveRequestsCount
    }
  }
`;
